import React, { useEffect, useState } from "react";
import { setNewUser } from "../../redux/actions/authActions";
import { updateDoc } from "firebase/firestore";
import { db, functions } from "../../config/firebase-config";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import CalendarMeetingCard from "./CalendarMeetingCard";
import { httpsCallable } from "firebase/functions";
import moment from "moment";
import { BiRefresh } from "react-icons/bi";
import { theme } from "../../utils/theme";
import { toast } from "react-toastify";
import AdhocMeetingCard from "./AdhocMeetingCard";
import Loader from "./../../components/Popups/Loader";
import { setSearchTerm } from "../../redux/actions/searchActions";
import { getCurrentUser } from "../../services/UserService"
import {
  getAllUserCalendarMeetings,
  fetchUpcomingCalendarMeetings, 
  fetchCalendarMeetings,
  fetchCalendarBotMeetings
} from "../../services/UserCalendarMeetingService"
import { getAllUserBotMeetings, fetchBotMeetings } from "../../services/UserBotMeetingService";
import PaginationBar from "../../components/Pagination/PaginationBar";
import { listCalendarMeetings } from "../../functions";

const Meetings = () => {
  const searchTerm = useSelector(
    (state) => state.searchReducer.searchTerm || ""
  );
  const [tab, setTab] = useState(1);
  const { meetings, calendarMeetings, upcomingCalendarMeetings, calendarBotMeetings } = useSelector(
    (state) => state.meetingsReducer
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { userData } = useSelector((state) => state.authReducer);
  const [addDummyData, setAddDummyData] = useState(null);
  const [refreshActive, setRefreshActive] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  // const [searchValue, setSearchValue] = useState("");


  const [count, setCount] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  // Dummy Meet - Start

  // useEffect(() => {
  //   const fetchDummyData = async () => {
  //     const getDummyData = async () => {
  //       try {
  //         let user = getCurrentUser();
  //         setIsLoading(true);
  //         let firebaseCalMeets = await getAllUserCalendarMeetings(user.uid, {},
  //           (response) => {
  //             return response.data;
  //           },
  //           (error) => {
  //               console.log("error: ", error);
  //               return [];
  //           }
  //         );
  //         setIsLoading(false);
  //         if (firebaseCalMeets.length > 0) {
  //           const latestMeeting = firebaseCalMeets[0];
  //           // Now you can use 'latestMeeting' as the topmost data
  //           const dummyData1 = latestMeeting;
  //           // console.log("Topmost data:", dummyData1);
  //           return dummyData1;
  //         } else {
  //           console.log("No data found in calendarMeetings");
  //         }
  //       } catch (error) {
  //         console.error("Error retrieving data:", error);
  //       }
  //     };
  //     const data = await getDummyData();
  //     setAddDummyData(data);
  //   };

  //   fetchDummyData();
  // }, []);
  // Dummy Meet - End

  // const updateExistingMeet = async (calMeet, upload) => {
  //   let user = getCurrentUser();
  //   await partialUpdateUserCalendarMeetings(user.uid, upload.id, {
  //     attendees: calMeet.attendees,
  //     attendeeEmails: calMeet.attendee_emails,
  //     botId: calMeet.bot_id,
  //     startTime: moment(calMeet.start_time).toDate(),
  //     endTime: moment(calMeet.end_time).toDate(),
  //     willRecord: calMeet.will_record,
  //     meetInvite: { meetId: calMeet?.meet_invite?.meeting_id || "" },
  //     meetingPlatform: calMeet?.meeting_platform || "",
  //   });
  // };

  // const addNewMeetToFirebase = async (newDoc) => {
  //   let user = getCurrentUser();
  //   return await createUserCalendarMeetings(user.uid, newDoc);
  // };

  // const fetchCalendarMeetings = async (showGreenToaster) => {
  //   setIsLoading(true);
  //   let user = getCurrentUser();
  //   let firebaseCalMeets = await getAllUserCalendarMeetings(user.uid, { "order_by": "createdAt", "order": "desc" },
  //     (response) => {
  //       return response.data;
  //     },
  //     (error) => {
  //         console.log("error: ", error);
  //         return [];
  //     }
  //   );
  //   setIsLoading(false);
  //   const uploadedMeets = [];
  //   firebaseCalMeets?.forEach((docSnap) => {
  //     uploadedMeets.push({ ...docSnap, id: docSnap.id });
  //   });
  //   setIsLoading(true);
  //   const calendarMeets = await listCalendarMeetings({
  //     user_id: user.uid,
  //     before: moment().add(1, "years").format("YYYY-MM-DD"),
  //     after: moment().format("YYYY-MM-DD"),
  //   });
  //   setIsLoading(false);
  //   const newArr = [];
  //   if (calendarMeets?.detail !== "Invalid token" && calendarMeets !== null) {
  //     import("../../redux/actions/appActions").then((ac) =>
  //       dispatch(ac.integrateCalendarPopup(false))
  //     );
  //     for (const calMeet of calendarMeets) {
  //       let meetId = calMeet.id;
  //       let meetUploaded = false;
  //       for (const upload of uploadedMeets) {
  //         if (upload?.calendarMeetId === meetId && !meetUploaded) {
  //           meetUploaded = true;
  //           //now update attendees list and emails as attendes might not have accepted invite at the time of calendar meet upload to firebase but maybe later on
  //           updateExistingMeet(calMeet, upload);
  //           newArr.push({
  //             ...upload,
  //             attendees: calMeet.attendees,
  //             attendeeEmails: calMeet.attendee_emails,
  //             botId: calMeet.bot_id,
  //             startTime: moment(calMeet.start_time),
  //             endTime: moment(calMeet.end_time),
  //             willRecord: calMeet.will_record,
  //             meetInvite: { meetId: calMeet?.meet_invite?.meeting_id || "" },
  //             meetingPlatform: calMeet?.meeting_platform || "",
  //           });
  //         }
  //       }
  //       if (!meetUploaded) {
  //         console.log("Unuploaded meet found", moment().format("HH:mm:ss"));
  //         let newDoc = {
  //           calendarMeetId: calMeet.id,
  //           willRecord: calMeet.will_record, //have to be updated
  //           startTime: moment(calMeet.start_time).toDate(), //have to be updated
  //           endTime: moment(calMeet.end_time).toDate(), //have to be updated
  //           meetInvite: { meetId: calMeet?.meet_invite?.meeting_id || "" }, //have to be updated
  //           meetingPlatform: calMeet?.meeting_platform || "",
  //           botId: calMeet.bot_id, //have to be updated
  //           organizerEmail: calMeet.organizer_email,
  //           attendees: calMeet.attendees, //have to be updated
  //           attendeeEmails: calMeet.attendee_emails, //have to be updated
  //           isHostedByMe: calMeet.is_hosted_by_me,
  //           icalUid: calMeet.ical_uid,
  //           createdAt: new Date(),
  //           favourite: false,
  //           hashTag: "#CalendarMeet",
  //           name: calMeet?.title || "",
  //         };
  //         console.log(
  //           "New Cal Meet Found to be added to Firebase(will be added if upcoming)",
  //           newDoc
  //         );
  //         if (
  //           moment().format("YYYYMMDDHHmmss") <
  //           moment(calMeet.end_time).format("YYYYMMDDHHmmss")
  //         ) {
  //           addNewMeetToFirebase(newDoc).then((res) => {
  //             console.log(
  //               "New Cal Meet Added Locally",
  //               {
  //                 ...newDoc,
  //                 id: res.id,
  //                 startTime: moment(calMeet.start_time),
  //                 endTime: moment(calMeet.end_time),
  //                 createdAt: moment(),
  //               },
  //               moment().format("HH:mm:ss")
  //             );
  //             newArr.push({
  //               ...newDoc,
  //               id: res.id,
  //               startTime: moment(calMeet.start_time),
  //               endTime: moment(calMeet.end_time),
  //               createdAt: moment(),
  //             });
  //           });
  //         }
  //       }
  //     }
  //     console.log("adding old uploaded meets locally");
  //     for (const upload of uploadedMeets) {
  //       //upcoming meetings: if they are mentioned in calendarMeetings then do nothing otherwise delete them because they were deleted by user
  //       if (
  //         moment().format("YYYYMMDDHHmmss") <
  //         moment(moment(upload?.startTime)?.toDate()).format("YYYYMMDDHHmmss")
  //       ) {
  //         let presentInCalMeets = false;
  //         calendarMeets.forEach((calMeet) => {
  //           if (calMeet.id === upload?.calendarMeetId) {
  //             presentInCalMeets = true;
  //           }
  //         });
  //         if (!presentInCalMeets) {
  //           //if it is not an upcoming meeting now-> delete
  //           console.log("upcoming meet not in calmeets so");
  //           let user = getCurrentUser();
  //           deleteUserCalendarMeetings(user.uid, upload.id);
  //           console.log("deleted upcoming meet from firebase");
  //         } else {
  //           //if it is still an upcoming meeting -> add to local array
  //           let uploadPresent = false;
  //           newArr?.forEach((item) => {
  //             if (item?.calendarMeetId === upload?.calendarMeetId)
  //               uploadPresent = true;
  //           });
  //           if (!uploadPresent) newArr.push(upload);
  //           console.log("added upcoming meet from firebase to local array");
  //         }
  //       }
  //       //past meetings: simply add to local array if not already there
  //       else {
  //         let uploadPresent = false;
  //         newArr?.forEach((item) => {
  //           if (item?.calendarMeetId === upload?.calendarMeetId)
  //             uploadPresent = true;
  //         });
  //         if (!uploadPresent) newArr.push(upload);
  //       }
  //     }
  //     import("../../redux/actions/meetingsActions")
  //       .then((ac) => dispatch(ac.setCalendarMeetings(newArr)))
  //       .then(() => {
  //         setTimeout(() => {
  //           if (showGreenToaster) {
  //             toast.success("Calendar meets are now up-to-date");
  //           }
  //           setRefreshActive(true);
  //         }, 15000);
  //       });
  //   } else {
  //     import("../../redux/actions/appActions").then((ac) =>
  //       dispatch(ac.integrateCalendarPopup(true))
  //     );
  //     import("../../redux/actions/meetingsActions").then((ac) =>
  //       dispatch(ac.setCalendarMeetings(calendarMeets))
  //     );
  //   }
  // };

  // const fetchAdhocMeetings = async (showGreenToaster) => {
  //   try {
  //     let user = getCurrentUser();
  //     setIsLoading(true);
  //     const botMeetSnaps = await getAllUserBotMeetings(user.uid, { "order_by": "createdAt", "order": "desc" },
  //       (response) => {
  //         return response.data;
  //       },
  //       (error) => {
  //           console.log("error: ", error);
  //           return [];
  //       }
  //     );
  //     setIsLoading(false);
  //     const arr = [];
  //     botMeetSnaps?.forEach((snap) => {
  //       arr.push({ ...snap, id: snap.id });
  //     });
  //     import("../../redux/actions/meetingsActions").then((ac) =>
  //       dispatch(ac.setMeetings(arr))
  //     );
  //     // console.log("Test Run");
  //     if (showGreenToaster) {
  //       toast.success("Adhoc meets are now up-to-date");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching adhoc meetings:", error);
  //   }
  // };

  useEffect(() => {
    if (searchParams.get("meet") && searchParams.get("past")) {
      setTab(2);
      setTimeout(() => {
        document
          .getElementById(searchParams.get("meet"))
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
        document
          .getElementById(searchParams.get("meet"))
          ?.classList.add("bg-[#f5f8ff]");
      }, 200);
      setTimeout(() => {
        document
          .getElementById(searchParams.get("meet"))
          ?.classList.remove("bg-[#f5f8ff]");
      }, 1000);
    } else if (searchParams.get("meet")) {
      setTab(1);
      setTimeout(() => {
        document
          .getElementById(searchParams.get("meet"))
          ?.scrollIntoView({ behavior: "smooth", block: "center" });
        document
          .getElementById(searchParams.get("meet"))
          ?.classList.add("bg-[#f5f8ff]");
      }, 200);
      setTimeout(() => {
        document
          .getElementById(searchParams.get("meet"))
          ?.classList.remove("bg-[#f5f8ff]");
      }, 1000);
    } else if (searchParams.get("pastAdhoc") !== null) {
      setTab(3);
    }
  }, [searchParams]);

  const fetchTabMeetings = async() => {
    let data;
    console.log(`fetchTabMeetings with tab: ${tab} page: ${page} limit: ${limit}`)
    setIsLoading(true);
    setRefreshActive(false);
    let createdAt = new Date();
    let filters = {"endTime": {"<=": createdAt}}
    if (tab == 1){
      data = await fetchUpcomingCalendarMeetings(dispatch, page, limit);
      const { records, count, totalPages } = data;
      setCount(count);
    }else if (tab == 2){
      data = await fetchCalendarMeetings(dispatch, page, limit, filters);
      const { records, count, totalPages } = data;
      setCount(count);
    }else if (tab == 3){
      data = await fetchBotMeetings(dispatch, page, limit);
      const { records, count, totalPages } = data;
      setCount(count);
    }else if (tab == 4){
      data = await fetchCalendarBotMeetings(dispatch, page, limit);
      const { records, count, totalPages } = data;
      setCount(count);
    }
    setIsLoading(false);
    setRefreshActive(true);
    return data;
  }

  const [isLoaded, setIsLoaded] = useState(false);
  useEffect(() => {
    if(isLoaded == true){
      fetchTabMeetings();
      console.log(`PAGE LIMIT:: ${page} ${limit}`)
    }else{
      setIsLoaded(true);
    }
  }, [page, limit])

  //
  
  //new for tab 2 calendar cards
  // Function to handle refreshing calendar meetings
  const refreshMeetings = async () => {
    // toast.info("Meetings would be updated soon!");
    if(page == 0){
      await fetchTabMeetings();
    }else{
      setPage((prev) => 0)
    }
    // toast.success("Meetings are now up-to-date");
  };

  const refreshUpcomingMeetings = async() => {
    setIsLoading(true);
    let user = getCurrentUser();
    let d = await listCalendarMeetings({
        user_id: user.uid,
        before: moment().add(1, "days").format("YYYY-MM-DD"),
        after: moment().add(-1, "days").format("YYYY-MM-DD"),
    });
    setIsLoading(false);
    return d;
  }

  useEffect(() => {
    console.log(`use Effect searchTerm: ${searchTerm} tab: ${tab}`);
    if (searchTerm) {
      searchHandleKeyDown(searchTerm);
    } else {
      if(isLoaded == false){
        refreshUpcomingMeetings();
      }
      refreshMeetings();
    }
  }, [searchTerm, tab]);

  useEffect(() => {
    setInterval(() => {
      refreshUpcomingMeetings();
      refreshMeetings();
    }, 1000 * 60 * 5);
  }, []);

  const searchHandleKeyDown = async (searchWord) => {
    if (tab === 3) {
      try {
        let user = getCurrentUser();
        setIsLoading(true);
        const botMeetSnaps = await getAllUserBotMeetings(user.uid, { "order_by": "createdAt", "order": "desc", "page": 0, "limit": 99999 },
          (response) => {
            return response.data;
          },
          (error) => {
              console.log("error: ", error);
              return [];
          }
        );
        setIsLoading(false);
        const filteredMeetings = botMeetSnaps.docs
          .map((snap) => ({ ...snap, id: snap.id }))
          .filter((meeting) => meetingContainsWord(meeting, searchWord));

        // Dispatch filtered meetings to the Redux store
        import("../../redux/actions/meetingsActions").then((ac) =>
          dispatch(ac.setMeetings(filteredMeetings))
        );

        // Show success toaster if requested
        // toast.success("Adhoc meets are now filtered by the search word");
        // console.log("filteredMeetings - ", filteredMeetings);
      } catch (error) {
        console.error("Error fetching adhoc meetings:", error);
      }
    }
    if (tab === 2) {
      try {
        let user = getCurrentUser();
        setIsLoading(true);
        const botMeetSnaps = await getAllUserCalendarMeetings(user.uid, { "order_by": "createdAt", "order": "desc" },
          (response) => {
            return response.data;
          },
          (error) => {
              console.log("error: ", error);
              return [];
          }
        );
        setIsLoading(false);
        const filteredMeetings = botMeetSnaps.docs
          .map((snap) => ({ ...snap, id: snap.id }))
          .filter((meeting) => meetingContainsWord(meeting, searchWord));

        // Dispatch filtered meetings to the Redux store
        import("../../redux/actions/meetingsActions").then((ac) =>
          dispatch(ac.setCalendarMeetings(filteredMeetings))
        );

        // Show success toaster if requested
        // toast.success("Adhoc meets are now filtered by the search word");
        // console.log("filteredMeetings - ", filteredMeetings);
      } catch (error) {
        console.error("Error fetching adhoc meetings:", error);
      }
    }
  };

  const meetingContainsWord = (meeting, searchWord) => {
    const regex = new RegExp(searchWord, "iu");

    if (
      meeting.generatedTranscript?.toLowerCase()?.match(regex) ||
      meeting.summary?.toLowerCase()?.match(regex) ||
      meeting.name?.toLowerCase()?.match(regex) ||
      meeting.notes?.some((note) => note?.name?.toLowerCase()?.match(regex)) ||
      meeting.questions?.some((question) =>
        question?.name?.toLowerCase()?.match(regex)
      ) ||
      meeting.tasks?.some((task) => task?.name?.toLowerCase()?.match(regex)) ||
      meeting.tasksForOthers?.some((task) =>
        task?.name?.toLowerCase()?.match(regex)
      )
      // Add more conditions as needed
    ) {
      return meeting;
    }

    return null;
  };

  return (
    <div className="overflow-x-hidden">
      <Loader isLoading={isLoading} />
      <div className="3xl:text-3xl text-2xl font-medium flex items-center gap-[10px]">
        Daily Standups
      </div>
      <div className="my-[10px]">
        Everyday work updates, dependencies and project updates.
      </div>
      <div className="flex gap-[20px] w-fit justify-between items-center mb-[15px]">
        <div
          className="cursor-pointer"
          onClick={() => {
            setTab(1);
          }}
          style={{ color: tab === 1 ? "#07457f" : "#384853" }}
        >
          <div className="mb-[2px] s10-step">Upcoming</div>
          <div
            className="bg-[#07457f] w-full mt-[5px]"
            style={{ padding: tab === 1 ? "1.2px" : "0px" }}
          ></div>
        </div>
        <div
          className="cursor-pointer"
          onClick={() => {
            setTab(2);
          }}
          style={{ color: tab === 2 ? "#07457f" : "#384853" }}
        >
          <div className="mb-[2px] s12-step">Past Calendar</div>
          <div
            className="bg-[#07457f] w-full mt-[5px]"
            style={{ padding: tab === 2 ? "1.2px" : "0px" }}
          ></div>
        </div>
        <div
          className="cursor-pointer"
          onClick={() => {
            setTab(3);
          }}
          style={{ color: tab === 3 ? "#07457f" : "#384853" }}
        >
          <div className="s23-step mb-[2px]">Past Adhoc</div>
          <div
            className="bg-[#07457f] w-full mt-[5px]"
            style={{ padding: tab === 3 ? "1.2px" : "0px" }}
          ></div>
        </div>
        <div
          className="cursor-pointer"
          onClick={() => {
            setTab(4);
          }}
          style={{ color: tab === 4 ? "#07457f" : "#384853" }}
        >
          <div className="s22-step mb-[2px]">Important</div>
          <div
            className="bg-[#07457f] w-full mt-[5px]"
            style={{ padding: tab === 4 ? "1.2px" : "0px" }}
          ></div>
        </div>
      </div>

      {refreshActive && (
          <div
            onClick={async() => {
              setRefreshActive(false);
              if(tab == 1){
                await refreshUpcomingMeetings();
              }
              fetchTabMeetings();
            }}
            className="flex cursor-pointer items-center w-fit text-sm gap-[5px] "
            style={{ color: theme.color }}
          >
            <BiRefresh className="text-xl sm:text-2xl 2xl:text-3xl " />{" "}
            Refresh {([1,2].indexOf(tab) > -1) ? 'calendar': (tab == 3) ? 'adhoc': 'important' } meetings
          </div>
      )}
      { (count > 0) && (
        <>
        <PaginationBar config={{
            count: count,
            page: page,
            setPage: setPage,
            limit: limit,
            setLimit: setLimit
          }} />
        </>
      )}
      {tab === 1 && (
        <>
          {upcomingCalendarMeetings?.detail === "Invalid token" ? (
            <span
              className="cursor-pointer"
              onClick={() => {
                navigate("/");
              }}
            >
              You need to sync your calendar
            </span>
          ) : (
            upcomingCalendarMeetings
              ?.map((data, idx) => {
                return (
                  <CalendarMeetingCard data={data} key={data?.id} idx={idx} fetchTabMeetings={fetchTabMeetings}/>
                );
              })
          )}
        </>
      )}
      {tab === 2 && (
        <>
          {calendarMeetings?.length > 0 ? (
            calendarMeetings
              ?.map((data, idx) => {
                if (
                  (moment().format("YYYYMMDDHHmmss") >
                  moment(moment(data?.startTime)?.toDate()).format("YYYYMMDDHHmmss"))
                )
                  return (
                    <CalendarMeetingCard
                      searchWord={searchTerm}
                      data={data}
                      key={data?.id}
                      idx={idx}
                      pastMeeting
                      fetchTabMeetings={fetchTabMeetings}
                    />
                  );
              })
          ) : (
            <CalendarMeetingCard
              // idx={idx}
              data={addDummyData}
              key={111}
              pastMeeting
              fetchTabMeetings={fetchTabMeetings}
            />
          )}
        </>
      )}
      {tab === 3 && (
        <>
          {meetings
            ?.sort((a, b) =>
              parseInt(
                moment(moment(a?.createdAt)?.toDate()).format("YYYYMMDDHHmmss")
              ) -
                parseInt(
                  moment(moment(b?.createdAt)?.toDate()).format("YYYYMMDDHHmmss")
                ) >
              0
                ? -1
                : 1
            )
            ?.map((data, idx) => {
              // console.log("Data from Meeting: ", data);
              return <AdhocMeetingCard data={data} key={data?.id} idx={idx} fetchTabMeetings={fetchTabMeetings}/>;
            })}
        </>
      )}
      {tab === 4 && (
        <>
          {calendarBotMeetings.map((data, idx) => {
              if (data?.ref == "calendarMeetings"){
                return (
                  <CalendarMeetingCard data={data} key={data?.id} pastMeeting fetchTabMeetings={fetchTabMeetings}/>
                );
              }else{
                return (
                  <AdhocMeetingCard data={data} key={data?.id} idx={idx} fetchTabMeetings={fetchTabMeetings}/>
                );
              }
            })}
        </>
      )}
    </div>
  );
};

export default Meetings;
